import { Subject } from 'rxjs';

export function onElementDestroy(element: HTMLElement): Subject<void> {
  const destroy$ = new Subject<void>();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const removed of Array.from(mutation.removedNodes)) {
        if (removed === element || (removed instanceof Node && removed.contains(element))) {
          destroy$.next();
          destroy$.complete();
          observer.disconnect();
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  return destroy$;
}
